import { ATTACK_MULTIPLIER } from '../constant';

export function gotPierce(piercePercent) {
  const random = Math.ceil(Math.random() * 100);
  if (random <= piercePercent) {
    return true;
  }
  return false;
}

export function gotAttack(luckPercent) {
  const random = Math.ceil(Math.random() * 10) * 10;
  if (random >= 90 - luckPercent) {
    return [random, ATTACK_MULTIPLIER.double];
  }
  if (random >= 60 - luckPercent) {
    return [random, ATTACK_MULTIPLIER.normal_half];
  }
  if (random >= 30 - luckPercent) {
    return [random, ATTACK_MULTIPLIER.normal];
  }
  return [random, ATTACK_MULTIPLIER.half];
}

export function playerAttack(
  playerAttack,
  isPierced,
  attackeMulitple,
  BossDefence,
  currentBossHp
) {
  let damage = Math.floor(playerAttack * attackeMulitple);
  let newBossHp;
  if (isPierced) {
    newBossHp = currentBossHp - damage;
  } else {
    newBossHp = currentBossHp - damage + BossDefence;
  }
  if (newBossHp > currentBossHp) {
    return currentBossHp;
  }
  if (newBossHp < 0) {
    return 0;
  }
  return newBossHp;
}

export function bossAttack(
  bossAttack,
  isPierced,
  attackeMulitple,
  playerDefence,
  currentPlayerHp
) {
  let damage = Math.floor(bossAttack * attackeMulitple);
  let newPlayerHp;
  if (isPierced) {
    newPlayerHp = currentPlayerHp - damage;
  } else {
    newPlayerHp = currentPlayerHp - damage + playerDefence;
  }
  if (newPlayerHp > currentPlayerHp) {
    return currentPlayerHp;
  }
  if (newPlayerHp < 0) {
    return 0;
  }
  return newPlayerHp;
}
